/**
 * Use to detect modile screen.
 * Clone from: https://github.com/ajerez/vue-mobile-detection/blob/master/src/components/VueMobileDetection.js
 * Because this function trigger only in the first time access our web.
 * We must clone this function and trigger it every time screen width is changed.
 * @returns {boolean}
 */
export function detectMobile() {
  // Need to minus 1px compare to lg for correct display.
  return window.innerWidth <= 1159;
}
